'use client';

const useOnChangeNumber = () => {
  const onChangeNumber = (e, form, formSetter) => {
    const newValue = e.target.value.replace(/\D/g, '');
    const name = e.target.name;

    let newForm = { ...form };
    newForm[name] = newValue

    formSetter && formSetter(newForm);
  };

  return onChangeNumber
}

export default useOnChangeNumber